import styled from 'styled-components'
import { noTouch } from '@/assets/styles/mixins.css'

const Radio = styled.div`
  position: relative;
  display: inline-block;
`

Radio.Input = styled.input`
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  border: 0;
  padding: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  overflow: hidden;
  pointer-events: none;
  white-space: nowrap;

  &:checked + * {
    --radio-inner-opacity: 1;
    --radio-inner-transform: scale(1);
  }
`

Radio.Label = styled.label`
  display: inline-block;
  padding: 10px 24px 13px 28px;
  font-size: 16px;
  cursor: pointer;
  transition: color 0.3s ease-out;

  &::before {
    content: '';
    position: absolute;
    top: 9px;
    left: 0;
    display: block;
    width: 20px;
    height: 20px;
    background: #fff;
    border: 1px solid var(--radio-outer-color, var(--color-border));
    border-radius: 50%;
    transition: border-color 0.3s linear;
  }

  &::after {
    content: '';
    position: absolute;
    top: 14px;
    left: 5px;
    display: block;
    width: 10px;
    height: 10px;
    background: var(--color-decor);
    border-radius: 50%;
    opacity: var(--radio-inner-opacity, 0);
    transform: var(--radio-inner-transform, scale(0));
    transition: opacity 0.25s, transform 0.25s ease-out;
  }

  ${noTouch()`
    &:hover {
      color: var(--color-secondary);
      --radio-outer-color: var(--color-extra);
    }
  `}
`

export default Radio
